import { render, staticRenderFns } from "./SBusyGlobal.vue?vue&type=template&id=4f1daa8a&scoped=true&"
import script from "./SBusyGlobal.vue?vue&type=script&lang=js&"
export * from "./SBusyGlobal.vue?vue&type=script&lang=js&"
import style0 from "./SBusyGlobal.vue?vue&type=style&index=0&id=4f1daa8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1daa8a",
  null
  
)

export default component.exports